import React, { useCallback, useEffect } from 'react';
import { STEPS_NAME } from '@theme/js/components/main/SmsVerification/constants';
import { useTranslations } from '@core/js/hooks/i18n';
import { useDispatch } from 'react-redux';
import { showSmsVerificationPopupAction, hideSMSVereficationDrawerStep } from '@theme/js/components/system/App/store/actions';
import { useLogout } from '@core/js/hooks/auth';
import { dispatcher } from 'dispatcher';
import { useAppSelector } from '@core/js/store/hooks';
import { prop } from 'ramda';

import style from '@theme/js/components/main/SmsVerification/index.scss';

const DrawerStep = () => {
    const t = useTranslations();
    const dispatch = useDispatch();
    const logout = useLogout();
    const verificationType = useAppSelector(prop('verificationType'));

    const closeDrawerOption = useCallback(() => {
        dispatch(hideSMSVereficationDrawerStep());
    }, [dispatch]);

    const openSmsVereficationFlow = useCallback(() => {
        closeDrawerOption();
        dispatch(showSmsVerificationPopupAction({ verificationType, step: STEPS_NAME.CODE }));
    }, [dispatch, verificationType, closeDrawerOption]);

    useEffect(() => {
        dispatcher.listen('auth:action:logout', closeDrawerOption);

        return () => {
            dispatcher.removeListener('auth:action:logout', closeDrawerOption);
        };
    }, [closeDrawerOption, logout]);

    return (
        <div className={style.drawerContainer}>
            <div className={style.closeIcon} onClick={closeDrawerOption}></div>
            <div className={style.drawerContent}>
                <div className={style.drawerHeader}>
                    <div className={`${style.icon} ${style.mobileIcon}`}></div>
                    <h2>{t('playtech.mobile.system.verification.numberNotVerified')}</h2>
                </div>
                <button onClick={openSmsVereficationFlow} className={style.drawerNextBtn}>
                    {t('playtech.mobile.system.dynamic-change-details.vereficationButtonLable')}
                </button>
            </div>
        </div >
    );
};

export default DrawerStep;
